import { render, staticRenderFns } from "./InstallmentPay.vue?vue&type=template&id=4b640e11&"
import script from "./InstallmentPay.vue?vue&type=script&lang=js&"
export * from "./InstallmentPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports